import { render } from "./ClientsHeader.vue?vue&type=template&id=63cf2dea&scoped=true"
import script from "./ClientsHeader.vue?vue&type=script&lang=js"
export * from "./ClientsHeader.vue?vue&type=script&lang=js"

import "./ClientsHeader.vue?vue&type=style&index=0&id=63cf2dea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cf2dea"]])

export default __exports__